import moment from "moment";
import { AnyDate } from "typings/DateTime";
import { HOURS_24_VALUE } from "Utils/date";

export enum DateTimeFormat {
   CALENDAR_DATE = "MM/DD/YYYY",
   CALENDAR_TIME = "h:mm A",
   CALENDAR_TIME_WITHOUT_MINUTES = "h A"
}

export type FormatCallback = (momentDate: moment.Moment) => string;
export type FormatOptions = {
   useUtc?: boolean,
   adjustMidnight?: boolean,
}

//Ideally the only entry point for moment.format()
export function format(date: AnyDate | undefined | null, format: string | FormatCallback, options?: FormatOptions): string {
   if (!date)
      return "";
   let momentDate = moment(date);
   if (options?.adjustMidnight && momentDate.hours() === 0 && momentDate.minutes() === 0 && momentDate.seconds() === 0) {
      momentDate = momentDate.add(-1, "millisecond");
   }
   if (options?.useUtc)
      momentDate.utc();

   return momentDate.format(typeof format === "string" ? format : format(momentDate));
}

// export const formatTime = (time: AnyDateTime, adjustMidnight?: boolean) => typeof time === "string" && isTimeOnly(time)
// ? formatTimeOnly(time)
// : format(time, (m) => getCalendarTimeFormat(m), { adjustMidnight: adjustMidnight });
export const formatTime = (time: AnyDate, adjustMidnight?: boolean) => format(time, (m) => getCalendarTimeFormat(m), { adjustMidnight: adjustMidnight });

export const formatCalendarDate = (date: AnyDate | undefined | null, useUtc?: boolean) => format(date, DateTimeFormat.CALENDAR_DATE, { useUtc: useUtc });
export const formatCalendarDateTime = (date: AnyDate | undefined | null) => format(date, (m) => `${DateTimeFormat.CALENDAR_DATE} - ${getCalendarTimeFormat(m)}`);

export function formatReservationTime(startTime: AnyDate | undefined | null, endTime: AnyDate | undefined | null): string {
   if (startTime && endTime)
      return `${formatTime(startTime)} - ${formatTime(endTime, true)}`;
   else if (startTime)
      return formatTime(startTime);
   else
      return "";
}

export const formatRelativeFromNow = (date: AnyDate): string => {
   const momentDate = moment(date);
   const formattedDate = momentDate.fromNow();
   return formattedDate;
}

export const formatRelativeCalendar = (date: string) => {
   const momentDate = moment(date);
   const formattedDate = momentDate.calendar();
   return formattedDate;
}

//PRIVATE 
//const formatTimeOnly = (time: TimeOnly) => formatTime(` ${fixTimeOnlyDayOverlap(time)}`);
//const fixTimeOnlyDayOverlap = (time: TimeOnly) => time == HOURS_24_VALUE ? "11:59:59" : time;
const getCalendarTimeFormat = (momentDate: moment.Moment) => momentDate.minutes() != 0 ? DateTimeFormat.CALENDAR_TIME : DateTimeFormat.CALENDAR_TIME_WITHOUT_MINUTES